import { useState } from 'react';

import Tippy from '@tippyjs/react';

import { cn } from 'lib/helpers/utility';

import Icon from 'components/shared/Icon/Icon';
import Confirm from 'components/shared/Modal/Confirm/Confirm';

const HeaderExitButton = ({ onExit, exitConfig = null, isCompact = false }) => {
  const [showExitConfirm, setShowExitConfirm] = useState(false);

  const tooltip = exitConfig?.tooltip || 'Exit Myriad Motion';

  const handleClick = () => {
    if (exitConfig?.confirm) {
      setShowExitConfirm(true);
    } else {
      onExit();
    }
  };

  return (
    <>
      <Tippy className="tippy-dark" content={tooltip} placement="left" touch={false}>
        <button
          type="button"
          data-qa="stepper-exit-btn"
          aria-label={tooltip}
          onClick={handleClick}
          className={cn(
            'absolute right-6 top-6 cursor-pointer rounded-md p-0.5 hover:bg-neutral-75 sm:right-3 sm:top-5',
            isCompact && 'right-6 top-5'
          )}>
          <Icon icon="close-linear" size={20} />
        </button>
      </Tippy>

      {exitConfig?.confirm && (
        <Confirm
          isOpen={showExitConfirm}
          handleClose={() => setShowExitConfirm(false)}
          title={exitConfig.confirm.title}
          message={exitConfig.confirm.message}
          icon="logout-2-mono"
          variant="warning"
          footerActions={{
            secondary: {
              text: 'Continue',
              onClick: () => setShowExitConfirm(false),
              color: 'neutral',
              style: 'outlined',
              dataQa: 'stepper-exit-continue-btn'
            },
            primary: {
              text: 'Exit',
              onClick: () => {
                setShowExitConfirm(false);
                onExit();
              },
              color: 'primary',
              dataQa: 'stepper-exit-confirm-btn'
            }
          }}
        />
      )}
    </>
  );
};

export default HeaderExitButton;
